module.exports = __webpack_public_path__ + "static/media/marketplace.3403dcdb.svg";